import type { CSSProperties } from 'react';

const PATHS = {
  download: 'M12 3v12m-5-5 5 5 5-5M5 16v5h14v-5',
  back: 'M20 12H4m6-6-6 6 6 6',
  help: 'M9 9a3 3 0 0 1 6 0c0 2-3 2-3 4m0 4h.01',
};
/** Ícones decorativos acompanham sempre um rótulo visível. */
export function Icon({
  name,
  size = 20,
  style,
}: {
  readonly name: keyof typeof PATHS;
  readonly size?: 16 | 20 | 24;
  readonly style?: CSSProperties;
}) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flexShrink: 0, ...style }}
    >
      {name === 'help' && <circle cx="12" cy="12" r="10" />}
      <path d={PATHS[name]} />
    </svg>
  );
}
